import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { USERS_ACTIONS, USERS_TYPES } from "./actions";
import {
  getUser,
  getUserPermissions,
  getUsers,
  updateUser as APIupdateUser,
  deleteUser as APIdeleteUser,
  createUser as APIcreateUser,
  syncUserPermissions as APIsyncUserPermissions,
  syncUserCompanies as APIsyncUserCompanies,
  sendPasswordResetMail as APIsendPasswordResetMail
} from "../../services/api/users";
import { navigateTo } from "../navigation/saga";
import { usersFilters } from "./selectors";
import { ajaxErrorHandler } from "../../libs/utils";

export function* watchUsersActions() {
  yield all([takeEvery(USERS_TYPES.CREATE_REQUEST, createUser)]);
  yield all([takeEvery(USERS_TYPES.LOAD_ALL_REQUEST, loadUsers)]);
  yield all([takeEvery(USERS_TYPES.UPDATE_FILTERS, loadUsers)]);
  yield all([takeEvery(USERS_TYPES.LOAD_REQUEST, loadUser)]);
  yield all([
    takeEvery(USERS_TYPES.LOAD_PERMISSIONS_REQUEST, loadUserPermissions)
  ]);
  yield all([takeEvery(USERS_TYPES.UPDATE_REQUEST, updateUser)]);
  yield all([takeEvery(USERS_TYPES.DELETE_REQUEST, deleteUser)]);
}

function* createUser(action) {
  const { values, permissions } = action.payload;

  try {
    const user = yield call(APIcreateUser, values);

    if (permissions) {
      yield call(APIsyncUserPermissions, user.id, permissions);
      yield call(APIsendPasswordResetMail, user.id);
    }

    if (values.companies) {
      yield call(APIsyncUserCompanies, user.id, values.companies);
    }

    yield put(USERS_ACTIONS.createSuccess(user));

    if (permissions) {
      yield put(USERS_ACTIONS.loadAllRequest());
      yield call(navigateTo, "/admin/users");
    } else {
      yield call(navigateTo, "/admin/employees");
    }
  } catch (e) {
    yield put(USERS_ACTIONS.createFailure(e));
  }
}

function* loadUsers(action) {
  try {
    const filters = yield select(usersFilters);
    const users = yield call(getUsers, filters);
    yield put(USERS_ACTIONS.loadAllSuccess(users));
  } catch (e) {
    yield put(USERS_ACTIONS.loadAllFailure(e));
  }
}

function* loadUser(action) {
  const { id } = action.payload;
  try {
    const user = yield call(getUser, id);
    yield put(USERS_ACTIONS.loadSuccess(user));
  } catch (e) {
    yield put(USERS_ACTIONS.loadFailure(e));
  }
}

function* loadUserPermissions(action) {
  const { id } = action.payload;
  try {
    const permissions = yield call(getUserPermissions, id);
    yield put(USERS_ACTIONS.loadPermissionsSuccess(permissions));
  } catch (e) {
    yield put(USERS_ACTIONS.loadPermissionsFailure(e));
  }
}

function* updateUser(action) {
  try {
    const { id, values, permissions, redirect } = action.payload;

    const user = yield call(APIupdateUser, id, values);

    if (permissions) {
      yield call(APIsyncUserPermissions, user.id, permissions);
    }

    if (values.companies) {
      yield call(APIsyncUserCompanies, user.id, values.companies);
    }

    yield put(USERS_ACTIONS.updateSuccess(user));
    if (redirect) {
      yield call(navigateTo, redirect);
    } else if (!permissions) {
      yield call(navigateTo, "/admin/employees");
    } else {
      yield call(navigateTo, "/admin/users");
    }
  } catch (e) {
    yield put(USERS_ACTIONS.updateFailure(e));
  }
}

function* deleteUser(action) {
  try {
    const { id } = action.payload;
    yield call(APIdeleteUser, id);
    yield put(USERS_ACTIONS.loadAllRequest());
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(USERS_ACTIONS.deleteFailure(e));
  }
}
